import React from "react"
import PropTypes from "prop-types";
import ItemRow from "shared/ItemRow";
import { ProfileIcon } from "shared/icons";
import { orgLocalDateTime } from "utils/dateHelpers";
import HistoricalAccessToolActionFilters from "./HistoricalAccessToolActionFilters";

const HistoricalAccessToolAction = ({ action }) => (
  <>
    <ItemRow
      collapsable
      itemRowHeaderControls
      itemRowHeaderContent={(
        <>
          <div className="flex">
            <div className="flex items-center screenreader-whitespace">
              <ProfileIcon user={action.grantor} className="w-4 h-4" />
              <b className="ml-2"> { action.grantor.fullName } </b>
              <span className="ml-1"> {action.actionType === "Grant" && `added ${action.accessLevel.replace("_", " ")}`} </span>
              <span className="ml-1"> {action.actionType === "Revoke" && "removed access"} </span>
            </div>
          </div>
          <div>
            { orgLocalDateTime(action.createdAt)}
          </div>
        </>
      )}
      itemRowBody={<HistoricalAccessToolActionFilters action={action} />}
    />
  </>
)

HistoricalAccessToolAction.propTypes = {
  action: PropTypes.object.isRequired,
}
export default HistoricalAccessToolAction;
